

























































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { EventBus } from '@/utils/EventBus';
import { Config } from '@/utils/Config';
import { Consoler } from '@/utils/Consoler';
import { ApplicationService } from '@/services/ApplicationService';
import { MemberApplication } from '@/models/memberApplication';
import { Helpers } from '@/utils/Helpers';
import TextInputFormField from '@/components/TextInputFormField.vue';
import { FormErrorDetail } from '@/models/formErrorDetail';
import { LocaleMessageArray } from 'vue-i18n';

interface HelpSection {
  title: string;
  text: string;
}

@Component({
  components: {
    TextInputFormField
  }
})
export default class ApplicationForm extends Vue {
  private data: MemberApplication = this.getEmptyApplication();

  private readonly RejectedQueryName: string = 'rejected';
  private readonly CompletedQueryName: string = 'completed';

  private completed: boolean = false;
  private rejected: boolean = false;

  private sending: boolean = false;
  private error: boolean = false;
  private validationError: boolean = false;
  private otherError: boolean = false;

  private formErrors: FormErrorDetail[] = [];
  private get baseUrl(): string
  {
    return Config.ExternalSettings.BaseUrl;
  }

  private helpSections: HelpSection[] = [];
  
  created() {
    const helpSectionLocales = this.$t('helpTextFull.sections') as LocaleMessageArray;
    for (const key in helpSectionLocales) {        
      if (helpSectionLocales.hasOwnProperty(key)) {
        this.helpSections.push({
          // tslint:disable-next-line:no-string-literal
          title: helpSectionLocales[key]['title'],
          // tslint:disable-next-line:no-string-literal
          text: this.replaceBaseUrl(helpSectionLocales[key]['text'])
        });
      }
    }

    this.completed = Helpers.GetQueryParameter(this.CompletedQueryName) === 'true';
    if (!this.completed) {
      this.rejected = Helpers.GetQueryParameter(this.RejectedQueryName) === 'true';
    }
  }

  private getEmptyApplication(): MemberApplication
  {
    return {
      ownerTypeIsCompany: false,
      ownerTypePrivateIsSingleOwner: null,
      firstName: '',
      lastName: '',
      organisation: '',
      personalNumber: '',
      organisationNumber: '',
      addressLine1: '',
      addressLine2: '',
      zipCode: '',
      city: '',
      email: '',
      mobile: '',
      phone: '',
      propertyNames: '',
      investmentDeductionExcess: false,
      investmentDeductionTwoPercent: false,
      supplementFullmakt: false,
      supplementLikvid: false,
      supplementHandling: false,
    }
  }

  private onGoBackClick() {
    window.location.href = Config.ExternalSettings.GoBackUrl;
  }

  private onRestartClick() {
    // Go to current location but without query
    window.location.href = window.location.pathname;
  }

  private resetErrors() {
    this.error = false;
    this.validationError = false;
    this.otherError = false;
    this.$validator.errors.clear();
    this.formErrors = [];
  }

  private onFormSubmit() {
    this.resetErrors();
    
    this.$validator.validateAll().then(valid => {
      Consoler.debugLog('Checking if form is valid:', valid, this.$validator.errors.all());
      if (!valid) {
        this.error = true;
        this.validationError = true;
        this.scrollToFirstValidationError();
        return;
      }
    
      this.sending = true;
      Consoler.debugLog('Submitting form', this.data);
      ApplicationService.sendApplication(this.data)
      .then((result) => {
        Consoler.debugLog('Successfully started the apply process, redirecting to:', result);
        window.location.href = result.data;
      })
      .catch((error) => {
        Consoler.debugWarn('Failed starting the apply process', error);
        this.error = true;

        if (error && error.response && error.response.data && error.response.data.errorDetails.length) {
          this.formErrors = error.response.data.errorDetails;
          this.validationError = true;
          this.$nextTick(() => {
            this.scrollToFirstValidationError();
          });
          Consoler.debugLog('setting formerrors: ', this.formErrors);
        } else if (error && error.response && error.response.status === 400) {
          Consoler.debugLog('Validation error occured (400), with no errorDetails from server.  ');
          this.validationError = true;
        } else {
          Consoler.debugLog('Other error occured when posting form (non-400).')
          this.otherError = true;
        }
      })
      .finally(() => {
        this.sending = false;
      });
    });
  }

  private scrollToFirstValidationError() {
    const formFieldErrorQuery = '.form-field.has-error';

    const generalDataElementError = this.$el.querySelector(`fieldset ${formFieldErrorQuery}`);
    if (generalDataElementError !== null) {
      Consoler.debugLog('Scrolling to first error', generalDataElementError);
      generalDataElementError.scrollIntoView({behavior: 'smooth', block: 'center'});
      return;
    }
    
    Consoler.debugWarn('Could not find an error element to scroll to..');
  }

  private hasValidationError(...fields: string[]): boolean {
    return fields.some(field => this.$validator.errors.has(field)) ||
      this.formErrors.some(e => fields.some(f => 'application.' + f.toLowerCase() === e.property.toLowerCase()));
  }

  private onResetClick() {
    this.resetErrors();
    this.data = this.getEmptyApplication();
  }

  private replaceBaseUrl(str: string) {
    return str.replace('{baseUrl}', this.baseUrl);
  }

  private resetCompanyFieldValues() {
    this.data.organisation = '';
    this.data.organisationNumber = '';
  }
}
